export class Fibra {
  id: number;
  id_gis: string;
  id_fibra_gis: string;
  fiber_number: string;
  stato: FiberStatusEnum;
  circuito_td: string;
  codice_servizio_tecnico: string;
  cliente: string;
  porte_apparato: string;
  porte_apparato_2: string;
  segment_rc: string;
  note: string;
  allegati: string;
  updated_by: string;
  updated_at: string;
  application: string; // WEB, MOBILE, PNI
  cavo_potenzialita_iru?: string; // potenzialità IRU del cavo di appartenenza, ND = cavo proprietario
}

export enum FiberStatusEnum {
  free = 'LIBERA',
  booked = 'PRENOTATA',
  unavailable = 'OCCUPATA',
  outOfOrder = 'GUASTA',
  bookedLD = 'BOOKED LD',
  toCheck = 'DA VERIFICARE',
  unusable = 'INUTILIZZABILE'
}
